import { IDescriptionData } from './description.types';

export const mockApplicationId = '6c31caf1-4d79-4abf-8c3e-dc50e263b63b';

export const mockedDescriptionData: IDescriptionData[] = [
  {
    long_description: 'Long description 1',
    icon: '',
    application_id: 'e4a0291d-fc4f-4abf-b9f8-78f3482ef944',
    url: 'https://long-description-1.com',
    preview_images: [
      {
        url: 'https://test.com',
        id: 'e990d4f6-5d21-48c7-b1ce-16b3b4c5ff8a',
      },
      {
        url: 'http://test1.com',
        id: '3d9ecb4a-f41d-45e2-9dd0-54168369af89',
      },
    ],
  },
  {
    long_description: 'Long description 2',
    icon: '',
    application_id: 'e4a0291d-fc4f-4abf-b9f8-78f3482ef944',
    url: 'https://long-description-2.com',
    preview_images: [
      {
        url: 'https://test.com',
        id: 'e990d4f6-5d21-48c7-b1ce-16b3b4c5ff8a',
      },
      {
        url: 'http://test1.com',
        id: '3d9ecb4a-f41d-45e2-9dd0-54168369af89',
      },
    ],
  },
];
